module.exports = __webpack_public_path__ + "img/chat_icon.a99773b5.png";